import { lazy } from "../Lazy";
export class ConfirmBeforeUnload {
    constructor() {
        this.tokens = [];
    }
    update_state() {
        window.onbeforeunload =
            this.tokens.length > 0
                ? () => true
                : null;
    }
    unregister(token) {
        this.tokens = this.tokens.filter(t => t !== token);
        this.update_state();
    }
    register() {
        const self = this;
        const token = new class {
            endLifetime() {
                this.revoke();
            }
            revoke() {
                self.unregister(this);
            }
        };
        this.tokens.push(token);
        this.update_state();
        return token;
    }
    static instance() {
        return ConfirmBeforeUnload._instance.get();
    }
}
ConfirmBeforeUnload._instance = lazy(() => new ConfirmBeforeUnload());
